module.exports = __webpack_public_path__ + "img/arrow_dmain_m.f3090e4b.svg";